import React from "react";
import MaterialIcon from "../../../components/MaterialIcon";
import { Skeleton } from "./CockpitPrimitives";

/** Labelled segmented choice in an offer's checkout panel. */
export function OfferChoice({ label, ariaLabel, options, value, onChange }) {
  return (
    <div className="cockpit-offer-choice">
      <span className="cockpit-offer-label">{label}</span>
      <div className="cockpit-tabs" role="tablist" aria-label={ariaLabel || label}>
        {options.map((opt) => (
          <button
            key={opt.key}
            type="button"
            role="tab"
            aria-selected={value === opt.key}
            className={`kj-tab cockpit-tab${value === opt.key ? " is-active" : ""}`}
            onClick={() => onChange(opt.key)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

/** "What you get" list of an offer; skeleton rows while the labels load. */
export function OfferFeatures({ title, features, loading }) {
  return (
    <>
      <div className="cockpit-offer-label">{title}</div>
      <ul className="cockpit-upsell-features">
        {loading
          ? [72, 58, 64].map((w) => (
              <li className="cockpit-upsell-feature" key={w}>
                <Skeleton height={14} width={`${w}%`} />
              </li>
            ))
          : features.map((label, idx) => (
              <li className="cockpit-upsell-feature" key={`${idx}-${label}`}>
                <MaterialIcon icon="check_circle" size={16} color="var(--kjuup-accent)" weight={400} />
                <span>{label}</span>
              </li>
            ))}
      </ul>
    </>
  );
}
